export default {"src":"/_next/static/image/public/images/ic_info_blue_background.54efdf6648c7285ad39b41430e036585.svg","height":23,"width":24};